/** Sorts numeric IDs and codes in the same order people read them. */
export const compareIds = (a: string, b: string) => a.localeCompare(b, "en", { numeric: true });

/** Narrows nullable GraphQL list entries to their present value. */
export const isPresent = <T>(value: T | null | undefined): value is T => value != null;
